{
  "login": {
    "title": "Welcome back",
    "subtitle": "Sign in to your account to continue",
    "emailTab": "Email & Password",
    "smsTab": "SMS",
    "emailLabel": "Email",
    "emailPlaceholder": "Email",
    "emailRequired": "Please input your email!",
    "emailInvalid": "Please enter a valid email address!",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Password",
    "passwordRequired": "Please input your password!",
    "loginButton": "Login",
    "loginWithGoogle": "Login with Google",
    "noAccount": "Don't have an account?",
    "signUp": "Sign up",
    "registerNow": "Register now",
    "loginFailed": "Login failed. Please try again.",
    "googleLoginFailed": "Google login failed. Please try again.",
    "loginWithCas": "Sign in with company account (CAS)",
    "casLoginFailed": "Company sign-in failed or your account has no access. Please try again or use another sign-in method.",
    "casCompleting": "Completing sign-in…",
    "phoneLabel": "Phone Number",
    "phonePlaceholder": "Phone Number",
    "phoneRequired": "Please input your phone number!",
    "codeLabel": "Verification Code",
    "codePlaceholder": "Code",
    "codeRequired": "Please input the code!",
    "sendCode": "Send Code",
    "resendCode": "Resend Code",
    "codeSent": "A verification code was sent to your phone.",
    "phoneInvalid": "Please enter a valid phone number.",
    "invalidCode": "Invalid verification code.",
    "codeExpired": "Verification code not found or expired. Please request a new one.",
    "phoneNotRegistered": "Phone number not registered or verified.",
    "codeSendFailed": "Could not send verification code. Please try again.",
    "codeVerifyFailed": "Login failed. Please check the code and try again.",
    "forgotPassword": "Forgot password?",
    "emailNotVerified": "Please verify your email before logging in.",
    "resendVerification": "Resend verification email",
    "resendVerificationSuccess": "If an account exists and is unverified, a verification email has been sent.",
    "fixErrors": "Please fix the errors below."
  },
  "register": {
    "title": "Create an account",
    "subtitle": "Get started with SmartAss AI",
    "haveAccount": "Already have an account?",
    "signIn": "Sign in",
    "failed": "Registration failed. Please try again.",
    "fixErrors": "Please fix the errors below.",
    "emailExists": "A user with this email already exists.",
    "phoneExists": "This phone number is already used by another account. Use a different number or leave the field empty.",
    "inviteInvalid": "Invite link is invalid or has expired.",
    "nameLabel": "Full name",
    "namePlaceholder": "Full name",
    "nameRequired": "Please input your full name!",
    "emailLabel": "Email",
    "emailPlaceholder": "Email",
    "emailRequired": "Please input your email!",
    "emailInvalid": "Please enter a valid email address!",
    "phoneLabel": "Phone number",
    "phonePlaceholder": "+1 234 567 8900",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Password",
    "passwordRequired": "Please input your password!",
    "passwordMin": "Password must be at least 8 characters!",
    "passwordPattern": "Password must include uppercase, lowercase, number, and special character (@$!%*?&)",
    "confirmPasswordLabel": "Confirm Password",
    "confirmPasswordPlaceholder": "Confirm Password",
    "confirmPasswordRequired": "Please confirm your password!",
    "passwordMismatch": "The two passwords do not match!",
    "submit": "Register",
    "alreadyHaveAccountDivider": "Already have an account?",
    "logIn": "Log in",
    "checkEmailTitle": "Check your email",
    "checkEmailMessage": "We've sent you a verification link. Please verify your email before logging in.",
    "resendVerification": "Resend verification email",
    "resendVerificationSuccess": "If an account exists and is unverified, a verification email has been sent.",
    "tenantInviteTitle": "Tenant Invitation",
    "tenantInviteDescription": "You've been invited to join a team. Complete registration to accept."
  },
  "forgotPassword": {
    "title": "Forgot password",
    "subtitle": "Enter your email and we'll send you a reset link",
    "emailLabel": "Email",
    "emailPlaceholder": "Email",
    "emailRequired": "Please input your email!",
    "emailInvalid": "Please enter a valid email address!",
    "submit": "Send reset link",
    "successMessage": "If an account exists, a reset link has been sent to your email.",
    "backToLogin": "Back to login",
    "failed": "Could not send reset link. Please try again."
  },
  "resetPassword": {
    "title": "Reset password",
    "subtitle": "Choose a new password for your account",
    "passwordLabel": "New password",
    "passwordPlaceholder": "New password",
    "passwordRequired": "Please input your new password!",
    "confirmPasswordLabel": "Confirm new password",
    "confirmPasswordPlaceholder": "Confirm new password",
    "confirmPasswordRequired": "Please confirm your new password!",
    "submit": "Reset password",
    "success": "Password updated successfully. You can now log in.",
    "failed": "Could not reset password. Please try again.",
    "invalidToken": "This reset link is invalid or has expired."
  },
  "verifyEmail": {
    "title": "Verify your email",
    "verifying": "Verifying your email...",
    "success": "Your email has been verified. You can now log in.",
    "successSignedIn": "Your email has been verified.",
    "failed": "Could not verify your email. Please try again.",
    "invalidToken": "This verification link is invalid or has expired.",
    "backToLogin": "Back to login",
    "backToProfile": "Back to profile"
  },
  "verifyLead": {
    "title": "Verify your contact details",
    "verifying": "Verifying your contact details...",
    "success": "Your contact details have been verified.",
    "failed": "Could not verify your contact details. The link may be expired or already used.",
    "invalidToken": "This verification link is invalid or has expired.",
    "enterCode": "Enter the 6-digit code we sent to your phone.",
    "codeRequired": "Please enter the 6-digit code.",
    "invalidCode": "That code is invalid. Please try again.",
    "submitCode": "Verify",
    "backToLogin": "Back to login"
  },
  "videoMeeting": {
    "loading": "Loading meeting…",
    "notFoundTitle": "Meeting not found",
    "notFoundDescription": "The requested video meeting could not be found or has expired."
  }
}
